import React from 'react'
import Dialog from 'material-ui-legacy/Dialog'

import CloseButton from './CloseButton'

/*
Props:
- title: Dialog title (optional)
- open: Boolean to show the dialog or not
- closeCallback: callback function, called when the Close button is clicked

Dialog contents should be passed via children.
*/
const ErrorDialog = (props) => (
  <Dialog
    style={props.style}
    onRequestClose={props.closeCallback}
    actions={[<CloseButton onTouchTap={props.closeCallback} />]}
    modal={false}
    open={props.open}
    title={props.title || "Something went wrong"}>
    {props.children}
  </Dialog>
)

export default ErrorDialog



// WEBPACK FOOTER //
// ./src/components/UI/ErrorDialog.jsx